export const messageRoutes = [
  {
    path: '/message/message-bar',
    component: () => import('@/views/modules/message/bar/message-popover'),
    meta: { name: '消息-导航', keepAlive: true }
  },
  {
    path: '/message/message-center',
    component: () => import('@/views/modules/message/message-center/message-center'),
    meta: { name: '消息中心', keepAlive: true }
  },
  {
    path: '/message/message-setting',
    component: () => import('@/views/modules/message/message-center/message-setting'),
    meta: { name: '消息中心', keepAlive: true }
  },
];
